import { create } from "zustand";

interface CurrentConversation {
  characterName: string;
  avatarUrl: string;
  characterId: string;
}

interface CurrentConversationStore {
  conversation: CurrentConversation | null;
  setConversation: (conversation: CurrentConversation) => void;
}

const useCurrentConversationStore = create<CurrentConversationStore>((set) => ({
  conversation: null,
  setConversation: (conversation) => set({ conversation }),
}));

export default useCurrentConversationStore;
